<template lang="pug">
.w-search.search-wrapper( :class='{ open }' )
  w-btn-icon(
    v-bind='{ size, hoverAction}'
    :hover='!noHover'
    @click.prevent='openSearch'
  )
    i-search
  input.form-control.input-sm.search-box(
    v-model='searchTerm'
    type='text'
    name='search'
    ref='input'
    placeholder='Search'
    @keyup.enter='doSearch'
    @keyup.escape='closeSearch'
    @blur='closeSearch'
  )
  //- TODO: auto-updating list
</template>

<script lang="js">
import WBtnIcon, { mixin } from './w-btn-icon'
import ISearch from 'icons/Magnify'

export default {
  name: 'SearchWidget',
  mixins: [ mixin ],
  components: { WBtnIcon, ISearch },
  props: {
    size: {
      type: String,
      default: 'lg2',
    }
  },
  data() {
    const searchTerm = this.$route.query.term
        ? this.$route.query.term : ''
    return {
      searchTerm,
      open: !!searchTerm
    }
  },
  created() {},
  mounted() {},
  methods: {
    doSearch() {
      this.$router.push({
        name: 'search',
        query: { term: this.searchTerm }
      })
    },
    toggle() {
      this.open = !this.open
    },
    openSearch() {
      this.open = true
      this.$refs.input.focus()
    },
    closeSearch() {
      this.open = false
    }
  },
  computed: {},
  watch: {
    '$route'( to, from ) {
      var searchTerm = to.query.term || ''
      this.searchTerm = searchTerm
    }
  }
}
</script>

<style lang="scss">
.w-search {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  min-width: 1.5em;
  >.search-box {
    height: unset;
    margin-right: -3em;
    padding: 4px 4px 4px 30px;
    border-radius: 0;
    /* border-top-left-radius: 100px; */
    /* border-bottom-left-radius: 100px; */
    width: 86px;
    opacity: 0;
    animation: close-search-input 1s ease;
    background: transparent;
    color: white;
    border: 0 none;
    &:focus {
      box-shadow: none;
    }
  }
  >.icon {
    position: absolute;
    top: 0px;
    left: 10px;
    padding: 3px;
    vertical-align: middle;
    color: white;
    text-shadow: 0 0px 2px rgba(0,0,0,0.3);
    animation: close-search-icon 1s ease;
    text-decoration: none !important;
    z-index: 20;
    .dashicons {
      font-size: 26px;
      height: 30px;
      width: 30px;
      text-decoration: none !important;
    }
  }
  &.open {
    > .search-box {
      animation: open-search-input 0.3s ease;
      width: 20em;
      opacity: 1;
      border-bottom: 2px solid white;
      margin: 0;
    }
    >.icon {
      left: -6px;
    }
  }
}
</style>
